import { render, staticRenderFns } from "./OfficialHolidays.vue?vue&type=template&id=48aa5f28&"
import script from "./OfficialHolidays.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports